import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetMembersProfilesQueryVariables = Types.Exact<{
  getProfilesInput: Types.GetProfilesInput;
}>;

export type GetMembersProfilesQuery = {
  __typename?: "Query";
  getProfiles: Array<{
    __typename?: "Profile";
    userUuid: string;
    clientUserUuid: string;
    firstName: string | null;
    lastName: string | null;
    isStaff: boolean;
  }>;
};

export type MemberProfileFragment = {
  __typename?: "Profile";
  userUuid: string;
  clientUserUuid: string;
  firstName: string | null;
  lastName: string | null;
  isStaff: boolean;
};

export const MemberProfileFragmentDoc = gql`
  fragment MemberProfile on Profile {
    userUuid
    clientUserUuid
    firstName
    lastName
    isStaff
  }
`;
export const GetMembersProfilesDocument = gql`
  query GetMembersProfiles($getProfilesInput: GetProfilesInput!) {
    getProfiles(getProfilesInput: $getProfilesInput) {
      ...MemberProfile
    }
  }
  ${MemberProfileFragmentDoc}
`;

/**
 * __useGetMembersProfilesQuery__
 *
 * To run a query within a React component, call `useGetMembersProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersProfilesQuery({
 *   variables: {
 *      getProfilesInput: // value for 'getProfilesInput'
 *   },
 * });
 */
export function useGetMembersProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMembersProfilesQuery,
    GetMembersProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMembersProfilesQuery,
    GetMembersProfilesQueryVariables
  >(GetMembersProfilesDocument, options);
}
export function useGetMembersProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMembersProfilesQuery,
    GetMembersProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMembersProfilesQuery,
    GetMembersProfilesQueryVariables
  >(GetMembersProfilesDocument, options);
}
export type GetMembersProfilesQueryHookResult = ReturnType<
  typeof useGetMembersProfilesQuery
>;
export type GetMembersProfilesLazyQueryHookResult = ReturnType<
  typeof useGetMembersProfilesLazyQuery
>;
export type GetMembersProfilesQueryResult = Apollo.QueryResult<
  GetMembersProfilesQuery,
  GetMembersProfilesQueryVariables
>;
